var _g, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6293_2288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 50,
    height: 50,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.319 41.5008H49.8107C50.339 41.439 50.7373 40.9914 50.7373 40.4595C50.7373 39.9276 50.339 39.48 49.8107 39.4183H40.319C39.918 39.3714 39.5257 39.559 39.3105 39.9005C39.0952 40.2421 39.0952 40.6769 39.3105 41.0185C39.5257 41.36 39.918 41.5476 40.319 41.5008Z",
    fill: "#1B9075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.319 52.8341H47.0907C47.4917 52.8809 47.884 52.6933 48.0992 52.3518C48.3145 52.0102 48.3145 51.5754 48.0992 51.2339C47.884 50.8923 47.4917 50.7047 47.0907 50.7516H40.319C39.918 50.7047 39.5257 50.8923 39.3105 51.2339C39.0952 51.5754 39.0952 52.0102 39.3105 52.3518C39.5257 52.6933 39.918 52.8809 40.319 52.8341Z",
    fill: "#1B9075"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5165 47.1674H40.319C39.918 47.2143 39.5257 47.0267 39.3105 46.6851C39.0952 46.3436 39.0952 45.9088 39.3105 45.5672C39.5257 45.2256 39.918 45.0381 40.319 45.0849H52.5165C53.0448 45.1466 53.4432 45.5943 53.4432 46.1262C53.4432 46.6581 53.0448 47.1057 52.5165 47.1674Z",
    fill: "#1B9075"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.369 60.0024H41.4523C37.7023 59.9946 34.6665 56.9524 34.6665 53.2024V37.6191C34.6743 33.8746 37.7079 30.841 41.4523 30.8333H51.369C55.119 30.8332 58.1612 33.8691 58.169 37.6191V53.2024C58.169 55.0059 57.4526 56.7355 56.1773 58.0107C54.9021 59.286 53.1725 60.0024 51.369 60.0024ZM41.4523 33.0858C38.9519 33.0935 36.9268 35.1186 36.919 37.6191V53.2024C36.919 55.7084 38.9464 57.7421 41.4523 57.7499H51.369C53.8805 57.7499 55.9165 55.7139 55.9165 53.2024V37.6191C55.9087 35.1131 53.875 33.0857 51.369 33.0858H41.4523Z",
    fill: "#1B9075"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 45,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#F3A8A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 12,
    height: 3,
    rx: 1.5,
    fill: "#F3A8A2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 50,
    width: 10,
    height: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 51,
    width: 10,
    height: 3,
    rx: 1.5,
    fill: "#F3A8A2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6293_2288",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6293_2288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6293_2288",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.b6cfa25335f6c66c6bb6ef57c0791af1.svg";
export { ForwardRef as ReactComponent };